/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Avg_Hr_One_LinerInputs */

const en_exp_avg_hr_one_liner = /** @type {(inputs: Exp_Avg_Hr_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The mean heart rate across the entire session, reflecting overall cardiovascular effort.`)
};

const de_exp_avg_hr_one_liner = /** @type {(inputs: Exp_Avg_Hr_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die mittlere Herzfrequenz der Einheit — zeigt die kardiovaskuläre Gesamtanstrengung.`)
};

/**
* | output |
* | --- |
* | "The mean heart rate across the entire session, reflecting overall cardiovascular effort." |
*
* @param {Exp_Avg_Hr_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_avg_hr_one_liner = /** @type {((inputs?: Exp_Avg_Hr_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Avg_Hr_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_avg_hr_one_liner(inputs)
	return de_exp_avg_hr_one_liner(inputs)
});